<template>
  <UserCommonLayout>
    <template #content>
      <LazyProSkillManagerCandidateBanner :company-name="companyName"/>
      <LazyProSkillManagerCommonTabMenu :container-class-name="'containerDash'"/>
      <LazyProSkillManagerCandidateList />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {useLoadingStore} from '~/store/loading/loadingStore';
import {useOrganizationService} from '~~/application/composables/service/useOrganizationService';
import {useUserStore} from '~/store/user/userStore';

const organizationService = useOrganizationService();
const loadingStore = useLoadingStore();
const userStore = useUserStore();
const { guard } = usePermissionGuard();

const companyName = ref("");

const handlerAssessmentMenuDoNotHavePermission = () => {
  if (!guard(
      userStore.isPermissionManageAssessment ||
      userStore.isSuperAdminType
  )) return;
}

const init = () => {
  Promise.all([organizationService.getOrganizationProSkillManagerInfo()]).then(resolve => {
    if(resolve[0].name){
      companyName.value = resolve[0].name.charAt(0).toUpperCase() + resolve[0].name.slice(1);
    }
    loadingStore.closeLoading();
  }).catch(() => {
    loadingStore.closeLoading();
  })
}

onMounted(() => {
  handlerAssessmentMenuDoNotHavePermission();
  init();
});
</script>

<style>
@import "~/assets/scss/business_style.scss";
</style>